module.exports = __webpack_public_path__ + "img/Skirt-Back-B3-Da-Fb-Gd-Hc-Ia.23b1df58.png";